<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/dproduct/index">Manage Product</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Create Product
      </h6>

      <div class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="saveProduct">
              <div class="row">
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">SKU</label>
                  <input v-model="product.SKU" type="text" class="form-control bdr-rad" placeholder="Auto-generated if blank" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Photo *</label>
                  <input @change="handlePhotoUpload" type="file" class="form-control bdr-rad" accept="image/*" required />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Name *</label>
                  <input v-model="product.Name" type="text" class="form-control bdr-rad" required />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Price *</label>
                  <input v-model="product.Price" type="number" step="0.01" class="form-control bdr-rad" required />
                </div>
              </div>

              <div class="row">
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Winery *</label>
                  <input v-model="product.Winery" type="text" class="form-control bdr-rad" required />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Country *</label>
                  <input v-model="product.Country" type="text" class="form-control bdr-rad" required />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Region *</label>
                  <input v-model="product.Region" type="text" class="form-control bdr-rad" required />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Varietal *</label>
                  <input v-model="product.Varietal" type="text" class="form-control bdr-rad" required />
                </div>
              </div>

              <div class="row">
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Type *</label>
                  <input v-model="product.Type" type="text" class="form-control bdr-rad" required />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="custom-label" style="font-size: small;">Body *</label>
                  <input v-model="product.Body" type="text" class="form-control bdr-rad" required />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label" style="font-size: small;">Description</label>
                  <textarea v-model="product.Description" class="form-control bdr-rad" rows="3"></textarea>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <button type="submit" class="btn btn-outline-primary mb-1 font-size_def bdr-rad">Create</button>
              </div>
            </form>

            <hr class="my-4" />

            <form @submit.prevent="importFromExcel">
              <div class="row align-items-end">
                <div class="col-md-9 mb-3">
                  <label class="custom-label" style="font-size: small;">Excel Upload</label>
                  <input
                    @change="handleExcelUpload"
                    ref="excelInput"
                    type="file"
                    class="form-control bdr-rad"
                    accept=".xls,.xlsx"
                    required
                  />
                  <small class="text-muted d-block mt-1">
                    Bulk import supports SKU, Photo, Name, Price, Winery, Country, Region, Varietal, Type, Body, Description.
                    If SKU is blank, it will be auto-generated as a minimum 3-digit value (for example, 001, 022, 999, 1001).
                  </small>
                </div>
                <div class="col-md-3 mb-3 text-md-end">
                  <button type="submit" class="btn btn-outline-primary mb-1 font-size_def bdr-rad">
                    Import Excel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      product: {
        SKU: '',
        Photo: '',
        Name: '',
        Price: '',
        Winery: '',
        Country: '',
        Region: '',
        Varietal: '',
        Type: '',
        Body: '',
        Description: '',
      },
      photoFile: null,
      excelFile: null,
    };
  },
  methods: {
    handlePhotoUpload(event) {
      const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
      this.photoFile = file;
      this.product.Photo = file ? file.name : '';
    },
    handleExcelUpload(event) {
      const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
      this.excelFile = file;
    },
    async saveProduct() {
      try {
        const formData = new FormData();
        formData.append('all_data[SKU]', this.product.SKU);
        formData.append('all_data[Name]', this.product.Name);
        formData.append('all_data[Price]', this.product.Price);
        formData.append('all_data[Winery]', this.product.Winery);
        formData.append('all_data[Country]', this.product.Country);
        formData.append('all_data[Region]', this.product.Region);
        formData.append('all_data[Varietal]', this.product.Varietal);
        formData.append('all_data[Type]', this.product.Type);
        formData.append('all_data[Body]', this.product.Body);
        formData.append('all_data[Description]', this.product.Description);
        if (this.photoFile) {
          formData.append('Photo', this.photoFile);
        }

        const { data } = await axios.post('/dproduct/create', formData, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'multipart/form-data',
          },
        });

        if (data && data.status === 200) {
          this.product = {
            SKU: '',
            Photo: '',
            Name: '',
            Price: '',
            Winery: '',
            Country: '',
            Region: '',
            Varietal: '',
            Type: '',
            Body: '',
            Description: '',
          };
          this.photoFile = null;
          alert('Dproduct created successfully.');
        } else {
          alert('Unable to create Dproduct.');
        }
      } catch (error) {
        console.log(error.response || error);
        alert('Unable to create Dproduct.');
      }
    },
    async importFromExcel() {
      if (!this.excelFile) {
        alert('Please select an Excel file.');
        return;
      }

      try {
        const formData = new FormData();
        formData.append('excel_file', this.excelFile);

        const { data } = await axios.post('/dproduct/import', formData, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'multipart/form-data',
          },
        });

        const failedRows = data && data.failed_rows && data.failed_rows.length
          ? data.failed_rows
              .slice(0, 10)
              .map((row) => `Row ${row.row}: ${row.error_text || 'Unknown error'}`)
              .join('\n')
          : '';
        const importedRows = data && data.imported_rows && data.imported_rows.length
          ? data.imported_rows
              .slice(0, 10)
              .map((row) => `Row ${row.row}: ${row.SKU || '-'} - ${row.Name || '-'} | ${row.StoreLocation || '-'} | Qty ${row.Qty || 0}`)
              .join('\n')
          : '';

        if (data && data.status === 200) {
          this.excelFile = null;
          this.$refs.excelInput && (this.$refs.excelInput.value = '');
          let message = `${data.message || 'Excel imported successfully.'}\nCreated ${data.created} product records and ${data.inventory_created || 0} inventory records.`;
          if (importedRows) {
            message += `\n\nImported rows:\n${importedRows}`;
          }
          if (failedRows) {
            message += `\n\nRows with issues:\n${failedRows}`;
          }
          alert(message);
        } else {
          let message = data && data.message ? data.message : 'Unable to import Excel file.';
          if (failedRows) {
            message += `\n\nRows with issues:\n${failedRows}`;
          }
          if (importedRows) {
            message += `\n\nImported rows:\n${importedRows}`;
          }
          alert(message);
        }
      } catch (error) {
        const response = error.response && error.response.data ? error.response.data : null;
        const failedRows = response && response.failed_rows && response.failed_rows.length
          ? response.failed_rows
              .slice(0, 10)
              .map((row) => `Row ${row.row}: ${row.error_text || 'Unknown error'}`)
              .join('\n')
          : '';
        const importedRows = response && response.imported_rows && response.imported_rows.length
          ? response.imported_rows
              .slice(0, 10)
              .map((row) => `Row ${row.row}: ${row.SKU || '-'} - ${row.Name || '-'} | ${row.StoreLocation || '-'} | Qty ${row.Qty || 0}`)
              .join('\n')
          : '';
        console.log(error.response || error);
        let message = (response && response.message) || 'Unable to import Excel file.';
        if (failedRows) {
          message += `\n\nRows with issues:\n${failedRows}`;
        }
        if (importedRows) {
          message += `\n\nImported rows:\n${importedRows}`;
        }
        alert(message);
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 10px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}
</style>
